import React from "react";
import { graphql } from "gatsby";
import { Layout } from "../layouts";
import PageHeader from "../components/core/PageHeader";
import { ModulesWrapper } from "../components/modules/ModuleWrapper/styled";
import { MODULE_MAPPING } from "../mapping";
import ModuleWrapper from "../components/modules/ModuleWrapper";
import { Container } from "../components/core/Container/styled";
import { InsightTitle } from "../components/insights/Title";

const InsightPage = ({ data }) => {
  const post = data.markdownRemark;
  const { title, modules, date, summary } = post.frontmatter;

  return (
    <Layout title={title}>
      <Container>
        <InsightTitle title={title} date={date} summary={summary} />

        <ModulesWrapper>
          {!!modules &&
            modules.map((module, index) => {
              const Module = MODULE_MAPPING[module.module];

              if (!Module) {
                return null;
              }
              return (
                <ModuleWrapper key={index}>
                  <Module {...module} />
                </ModuleWrapper>
              );
            })}
        </ModulesWrapper>
      </Container>
    </Layout>
  );
};

export const query = graphql`
  query ($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        date
        summary
        modules {
          image
          text
          module
        }
      }
    }
  }
`;

export default InsightPage;
